// Issue page with table

import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  Select,
  MenuItem,
  SelectChangeEvent,
  useTheme,

} from '@mui/material';
import axios from 'axios';
import {
  SupportTicketFields,
  SupportTicket,
  SupportTicketTable,
} from '../../../constants/Supportfields';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ThemeProvider } from '@mui/material/styles';
import getTheme from '../../../theme/theme';
import { BASEURL } from '../../../constants/Common';
import BasicTable, { Column } from '../../../components/table';
import FloatingButton from './FloatingButton';
import { Dialog, DialogContent, DialogActions } from '@mui/material';

const CreateTicketpage: React.FC = () => {
  const navigate = useNavigate();
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [userdetails, setUserDetails] = useState<SupportTicketTable[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [refresh, setRefresh] = useState<boolean>(false);
  const fromusername = (localStorage.getItem('username') || '');
  const storedAuthData = localStorage.getItem('authData');
  const user_id = storedAuthData ? parseInt(storedAuthData, 10) : null;
  const [isSaving, setIsSaving] = useState(false);





  const storedAdmindata = localStorage.getItem('userRoleAdmin');
  let Userrole: any = null;
  if (storedAdmindata) {
    Userrole = JSON.parse(storedAdmindata);
  } else {
    console.log('No data found in localStorage');

  }

  console.log("Userrolehelpdesk:", Userrole)
  const sendemail = localStorage.getItem('email');
  let eMail: any = null;

  if (sendemail) {
    eMail = JSON.parse(sendemail);
  } else {
    navigate('/login')
  }

  const organizationId = localStorage.getItem('orgid');
  let orgid: any = null;

  if (organizationId) {
    orgid = JSON.parse(organizationId);
  } else {
    navigate('/login')
  }

  const [newTicket, setNewTicket] = useState<SupportTicket>({
    issue_id: null,
    user_id: user_id,
    issue_status: 'Active',
    username: fromusername,
    email: eMail,
    org_id: orgid,
    issue_comments: '',
    issue_category: '',
    issue_description: '',
    attachments: null,
    attachments2: null,
    attachments3: null,
    attachments4: null,
    attachments5: null,
    attachments6: null,
  });
  const [newTickettable, setNewTicketTable] = useState<SupportTicketTable>({
    issue_id: null,
    user_id: user_id,
    org_id: orgid,
    issue_status: '',
    created_date: '',
    resolved_date: '',
    issue_comments: '',
    issue_category: '',
    issue_description: '',
    attachments: null,
    attachments2: null,
    attachments3: null,
    attachments4: null,
    attachments5: null,
    attachments6: null,
  });

  const handleInputChange = (
    event:
      | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
      | SelectChangeEvent<string>
  ) => {
    const { name, value } = event.target;
    setNewTicket({ ...newTicket, [name]: value });
  };

  const handleFilesChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newFiles = Array.from(event.target.files!) as File[];
    const uniqueFilesToAdd = newFiles.filter(
      (file) =>
        !selectedFiles.some((selectedFile) => selectedFile.name === file.name)
    );

    if (uniqueFilesToAdd.length + selectedFiles.length > 6) {
      toast.error('You can only upload up to 6 files.');
      return;
    }

    setSelectedFiles((prevFiles) => [...prevFiles, ...uniqueFilesToAdd]);
  };

  const handleRemoveFile = (fileName: string) => {
    setSelectedFiles((prevFiles) =>
      prevFiles.filter((file) => file.name !== fileName)
    );
  };

  const handleButtonClick = (evt: React.MouseEvent<HTMLButtonElement>) => {
    evt.preventDefault();
    if (selectedFiles.length > 5) {
      toast.error('You can upload a maximum of 6 files.');
    } else {
      document.getElementById('fileInput')?.click();
    }
  };

  //fetch all tickets
  const fetchAllIssues = async () => {
    try {
      const response = await axios.get(BASEURL + '/issues/');
      const usersData = response.data;
      console.log('usersData:', usersData);

      setUserDetails(usersData);

      setLoading(false);
    } catch (error) {
      console.error('Error fetching user details:', error);
      setLoading(false);
    }
  };

  // console.log("userdetails:", userdetails);
  useEffect(() => {
    fetchAllIssues();
  }, [refresh]);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (newTicket.issue_category.length === 0) {
      toast.error('Please select category.');
      return;
    }
    if (newTicket.issue_description.length === 0) {
      toast.error('Description is required');
      return;
    }
    setIsSaving(true);
    try {
      newTicket.attachments = selectedFiles[0];
      newTicket.attachments2 = selectedFiles[1];
      newTicket.attachments3 = selectedFiles[2];
      newTicket.attachments4 = selectedFiles[3];
      newTicket.attachments5 = selectedFiles[4];
      newTicket.attachments6 = selectedFiles[5];

      console.log('newTicket:', newTicket);
      const url_create = BASEURL + '/issues/create/';
      const response = await axios.post(url_create, newTicket, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      // Construct the new user details object
      const newUserDetail: SupportTicketTable = {
        org_id: newTicket.org_id,
        user_id: newTicket.user_id,
        resolved_date: "",
        issue_status: newTickettable.issue_status,
        created_date: newTickettable.created_date,
        issue_id: newTickettable.issue_id,
        issue_comments: newTicket.issue_comments,
        issue_category: newTicket.issue_category,
        issue_description: newTicket.issue_description,
        attachments: newTicket.attachments,
        attachments2: newTicket.attachments2,
        attachments3: newTicket.attachments3,
        attachments4: newTicket.attachments4,
        attachments5: newTicket.attachments5,
        attachments6: newTicket.attachments6,
      };

      // Update the user details state
      setUserDetails((prevUserDetails) => [...prevUserDetails, newUserDetail]);

      // Reset the form fields
      setNewTicket({
        issue_id: null,
        user_id: null,
        username: fromusername,
        email: eMail,
        issue_status: 'Active',
        org_id: orgid,
        issue_comments: '',
        issue_category: '',
        issue_description: '',
        attachments: null,
        attachments2: null,
        attachments3: null,
        attachments4: null,
        attachments5: null,
        attachments6: null,
      });
      setSelectedFiles([]);
      setDialogOpen(true);
      if (response?.status === 201) {
        toast.success(response?.data?.message || 'Support ticket created successfully')
      }
      setIsSaving(false);
    } catch (error) {
      toast.error('Error creating support ticket');
      setIsSaving(false);
    }
  };


  const columns: Column[] = [
    { id: 'sno', label: 'S.No', align: 'left' },
    { id: 'category', label: 'Category', align: 'left' },
    { id: 'description', label: 'Description', align: 'left' },
    { id: 'comments', label: 'Comments', align: 'left' },
    { id: 'status', label: 'Status', align: 'left' },
    // { id: 'createdon', label: 'Created On', align: 'right' },
    // { id: 'resolvedon', label: 'Resolved On', align: 'right' },
    {
      id: 'createdon',
      label: 'Created On',
      align: 'left',
      // style: { whiteSpace: 'nowrap' }
    },
    {
      id: 'resolvedon',
      label: 'Resolved On',
      align: 'left',
      // style: { whiteSpace: 'nowrap' }
    },
  ];

  const handleEditUser = (userId: null | number) => {
    localStorage.setItem('selectedIdforTicket', JSON.stringify(userId));
    navigate('/issueeditdetails', { state: { userId: userId } });
  };

  const rows = userdetails
    ? (Userrole === 'Support'
      ? userdetails
      : Userrole === 'Admin'
        ? userdetails.filter((user) => user.org_id === orgid)
        : userdetails.filter((user) => user.org_id === orgid && user.user_id === user_id))
      .map((user, index) => ({
        id: index + 1,
        sno: (
          <Link
            to={'/issueeditdetails'} // Pass the user ID as a URL parameter
            onClick={() => handleEditUser(user.issue_id)}
          >
            {user.issue_id}
          </Link>
        ),
        category: user.issue_category,
        comments: user.issue_comments,
        description: user.issue_description,
        status: user.issue_status,
        createdon: user.created_date ? user.created_date.split('T')[0] : '',
        resolvedon: user.resolved_date ? user.resolved_date.split('T')[0] : '',
      }))
      .reverse()
    : [];



  return (
    <ThemeProvider theme={getTheme()}>
      <Box sx={{ mt: '-80px' }}>
        <Typography variant='h6' gutterBottom>
          <Link to={'/usersupporthome'}>Support Tickets</Link> &gt; Create New
        </Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={1}>
            {SupportTicketFields.map((field) => (
              field.name !== 'attachments' && (
                <React.Fragment key={field.name}>
                  <Grid item xs={3} sx={{ mt: '20px', ml: '30px' }}>
                    <Typography>
                      <strong>{field.title}</strong>
                    </Typography>
                  </Grid>
                  <Grid item xs={3} sx={{ mb: '-10px', ml: '-30px' }}>
                    {field.type === 'dropDown' ? (
                      <Box sx={{ mt: '15px', border: '1px solid #000000' }}>
                        <Select
                          value={
                            newTicket[field.name] !== null
                              ? (newTicket[field.name] as string)
                              : ''
                          }
                          onChange={handleInputChange}
                          fullWidth
                          variant='outlined'
                          name={field.name}
                        >
                          {field.options?.map((option, index) => (
                            <MenuItem key={index} value={option}>
                              {option}
                            </MenuItem>
                          ))}
                        </Select>
                      </Box>
                    ) : field.type === 'textArea' ? (
                      <TextField
                        name={field.name}
                        value={newTicket[field.name]}
                        onChange={handleInputChange}
                        fullWidth
                        margin='normal'
                        variant='outlined'
                        multiline
                        rows={field.height}
                      />
                    ) : (
                      <TextField
                        name={field.name}
                        type={field.type}
                        value={newTicket[field.name]}
                        onChange={handleInputChange}
                        fullWidth
                        margin='normal'
                        variant='outlined'
                      />
                    )}
                  </Grid>
                </React.Fragment>
              )
            ))}
            {/* Move attachments section here */}
            <React.Fragment key="attachments">
              <Grid item xs={3} sx={{ mt: '20px', ml: '30px' }}>
                <Typography>
                  <strong>Attachments</strong>
                </Typography>
              </Grid>
              <Grid item xs={3} sx={{ mb: '-10px', ml: '-30px' }}>
                <Box sx={{ mt: '15px', width: '300px' }}>
                  <input
                    id='fileInput'
                    type='file'
                    name='file'
                    onChange={handleFilesChange}
                    accept='.jpg, .jpeg, .png'
                    multiple
                    style={{ display: 'none' }}
                  />
                  <Button variant='contained' color='primary' onClick={handleButtonClick}>
                    Browse
                  </Button>
                  {selectedFiles.map((file) => (
                    <div key={file.name}>
                      <Grid mt={1} container spacing={0} sx={{ mt: 1 }}>
                        <Grid item md={6} xs={12} sx={{ wordWrap: 'break-word' }}>
                          <span style={{ display: 'block', overflowWrap: 'break-word' }}>{file.name}</span>
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <Button onClick={() => handleRemoveFile(file.name)}
                            color='error'
                            variant='text'
                            sx={{ mt: { xs: 1, md: 0 } }}>
                            Remove
                          </Button>
                        </Grid>
                      </Grid>
                    </div>
                  ))}

                </Box>
              </Grid>
            </React.Fragment>
          </Grid>
          <Box sx={{ mt: '50px', display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              type='submit'
              variant='contained'
              color='primary'
              sx={{ marginRight: '20px', width: '75px', '&:disabled': { bgcolor: 'grey.400', color: 'grey.700' } }}
              disabled={isSaving}
            >
              Save
            </Button>
          </Box>
        </form>
        <Dialog open={dialogOpen} onClose={() => {
          setDialogOpen(false);
          setRefresh(!refresh);
        }}>
          <DialogContent>
            <Typography variant='body1'>
              Dear User, Thank you for submitting your issue. We'll address it
              promptly.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setDialogOpen(false);
                setRefresh(!refresh); // Trigger reload
              }}
              variant='contained' color='primary'
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* Issue table start */}

        <h3 style={{ marginTop: '60px' }}>Ticket History</h3>
        <Box sx={{ marginTop: '10px' }}>
          <BasicTable columns={columns} rows={rows} />
        </Box>

        <FloatingButton />
      </Box>
    </ThemeProvider>
  );
};

export default CreateTicketpage;